import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import * as actions from './checkin-select.actions';
import { CheckinSelectState } from './checkin-select.state';

/**
 * checkinSelect initial state
 */
export const checkinSelectInitialState: CheckinSelectState = {
  model: { isOpen: false },
};

/**
 * List of basic actions for CheckinSelect Store
 */
export const checkinSelectReducerFeatures: ReducerTypes<CheckinSelectState, ActionCreator[]>[] = [
  on(actions.setCheckinSelect, (_state, payload) => ({ ...payload })),

  on(actions.updateCheckinSelect, (state, payload) => ({ ...state, ...payload })),

  on(actions.resetCheckinSelect, () => checkinSelectInitialState),

  on(actions.updateViewDetailsOpenStatus, (state, payload) => ({ ...state, model: { ...payload } })),
];

/**
 * CheckinSelect Store reducer
 */
export const checkinSelectReducer = createReducer(checkinSelectInitialState, ...checkinSelectReducerFeatures);
